export const emailRules = [
  v => !!v || 'Email is required',
  v =>
    /^(?!.*\.{2,})(?!.*@.*@.*)(?!.*@\.{2,})(?!.*\.$)(?!.*\.\.$)[^\s@]+\@[^\s@]+\.[^\s@]+$/.test(
      v,
    ) || 'Must be a valid email.',
];
